import { BaseService } from "./base.service";
import { Injectable } from "@angular/core";

type PushPermissionSubscribeResult = {
    status: 'granted' | 'denied' | 'unsupported' | 'error',
    message: string,
    subscribed: boolean,
    debugInfo?: string
};
@Injectable({
    providedIn: 'root',
})
export class NotificationMiddlewareService {

    serviceWorker = '/assets/swk.js'
    isSubscribed = false;
    applicationServerPublicKey = 'BC4Fb_DVw4I9pQlkpPMi0cZcwC42mEuUXwLMjm0mj24OCwI0HUIv5V4m_bPZUIhl28mBB-p4PXguSUlgs1EoJUw';
    private lastRegisteredEndpoint: string | null = null;

    constructor(
        private _baseService: BaseService
    ) {
    }
    updateOnlineStatus(event) {
        var condition = navigator.onLine ? "Live" : "Currently offline";
        this.notify(condition);
    }
    // Notification
    notify(msg) {
        if (!("Notification" in window)) {
            alert("This browser does not support desktop notification");
        } else if (Notification.permission === "granted") {
            // If it's okay let's create a notification
            var notification = new Notification(msg);
        } else if (Notification.permission !== "denied") {
            Notification.requestPermission(function (permission) {
                // If the user accepts, let's create a notification
                if (permission === "granted") {
                    var notification = new Notification(msg);
                }
            });
        }
    }
    private isPushSupported(): boolean {
        return typeof window !== 'undefined'
            && 'Notification' in window
            && 'serviceWorker' in navigator
            && 'PushManager' in window;
    }

    private getKeyAsBase64(subscription: PushSubscription, keyName: PushEncryptionKeyName): string {
        const key = subscription.getKey(keyName);
        if (!key) {
            return '';
        }
        return this.base64Encode(key);
    }

    private buildPushPayload(subscription: PushSubscription): { PushEndpoint: string, PushP256DH: string, PushAuth: string } {
        return {
            PushEndpoint: subscription.endpoint,
            PushP256DH: this.getKeyAsBase64(subscription, 'p256dh'),
            PushAuth: this.getKeyAsBase64(subscription, 'auth')
        };
    }

    private buildPushDebugInfo(payload: { PushEndpoint: string, PushP256DH: string, PushAuth: string }): string {
        return "";
        const endpointPreview = payload.PushEndpoint ? `${payload.PushEndpoint.substring(0, 48)}...` : 'missing';
        const p256dhLength = payload.PushP256DH ? payload.PushP256DH.length : 0;
        const authLength = payload.PushAuth ? payload.PushAuth.length : 0;
        return `endpoint:${payload.PushEndpoint ? 'ok' : 'missing'} (${endpointPreview}) | p256dh:${payload.PushP256DH ? 'ok' : 'missing'}(len=${p256dhLength}) | auth:${payload.PushAuth ? 'ok' : 'missing'}(len=${authLength})`;
    }

    private registerDeviceSubscription(subscription: PushSubscription): Promise<boolean> {
        const payload = this.buildPushPayload(subscription);
        if (!payload.PushEndpoint || !payload.PushP256DH || !payload.PushAuth) {
            return Promise.resolve(false);
        }
        if (this.lastRegisteredEndpoint === payload.PushEndpoint) {
            return Promise.resolve(true);
        }

        return new Promise((resolve) => {
            try {
                this._baseService.getDataAPI('AddDevice', payload).subscribe({
                    next: () => {
                        this.lastRegisteredEndpoint = payload.PushEndpoint;
                        resolve(true);
                    },
                    error: () => resolve(false)
                });
            } catch (err) {
                resolve(false);
            }
        });
    }

    initialiseServiceWorker(all_Init) {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register(this.serviceWorker).then(
                (resp) => {
                    this.handleSWRegistration(all_Init, resp)
                });
        } else {
        }
    };
    // Once the service worker is registered set the initial state

    subscribe(all_Init, reg) {
        var subscribeParams = { userVisibleOnly: true };

        //Setting the key of our VAPID key pair.
        var applicationServerKey = all_Init.urlB64ToUint8Array('BEY2atWHDb4rGaWezlW3bQA8LCOERm-tZOo45zWIPABpYAUttBb8tFmpkJgHtgqcSxIPOSsqWJc5lM-5-6sZx1w');
        subscribeParams['applicationServerKey'] = applicationServerKey;

        reg.pushManager.subscribe(subscribeParams)
            .then(async function (subscription) {
                all_Init.isSubscribed = true;
                if (subscription) {
                    try {
                        await all_Init.registerDeviceSubscription(subscription);
                    } catch (err) {
                    }
                }
            })
            .catch(function (e) {
            });
    }


    urlB64ToUint8Array(base64String) {
        var padding = '='.repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');

        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);

        for (var i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    base64Encode(arrayBuffer) {
        if (!arrayBuffer) {
            return '';
        }
        return btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
    }
    initialiseState(all_Init, reg) {
        // Are Notifications supported in the service worker?
        if (!(reg.showNotification)) {
            return;
        }

        // Check if push messaging is supported
        if (!('PushManager' in window)) {
            return;
        }

        // We need the service worker registration to check for a subscription
        // navigator.serviceWorker.ready.then(function (reg) {
        // Do we already have a push message subscription?
        reg.pushManager.getSubscription()
            .then(async function (subscription) {
                all_Init.isSubscribed = subscription;
                if (all_Init.isSubscribed) {
                    if (subscription) {
                        try {
                            await all_Init.registerDeviceSubscription(subscription);
                        } catch (err) {
                        }
                    }
                } else {
                    all_Init.subscribe(all_Init, reg);
                }
            })
            .catch(function (err) {
            });
        // });
    }

    handleSWRegistration(all_Init, reg) {
        if (reg.installing) {
        } else if (reg.waiting) {
        } else if (reg.active) {
        }

        all_Init.initialiseState(all_Init, reg);
    }


    init() {
        if (typeof 'BEY2atWHDb4rGaWezlW3bQA8LCOERm-tZOo45zWIPABpYAUttBb8tFmpkJgHtgqcSxIPOSsqWJc5lM-5-6sZx1w' === 'undefined') {
            return;
        };
        let all_Init = this;
        Notification.requestPermission().then(function (status) {
            if (status === 'denied') {
            } else if (status === 'granted') {
                navigator.serviceWorker.getRegistrations().then(registrations => {
                });
                all_Init.initialiseServiceWorker(all_Init);
            }
        });
    }

    public async requestNotificationPermissionAndSubscribe(): Promise<PushPermissionSubscribeResult> {
        if (!this.isPushSupported()) {
            return {
                status: 'unsupported',
                message: 'Thiết bị hoặc trình duyệt chưa hỗ trợ push notification.',
                subscribed: false
            };
        }

        try {
            const permission = await Notification.requestPermission();
            if (permission !== 'granted') {
                return {
                    status: 'denied',
                    message: permission === 'denied'
                        ? 'Bạn đã từ chối quyền thông báo.'
                        : 'Bạn chưa cấp quyền thông báo.',
                    subscribed: false
                };
            }

            const registration = await navigator.serviceWorker.register(this.serviceWorker);
            const existingSubscription = await registration.pushManager.getSubscription();
            if (existingSubscription) {
                const payload = this.buildPushPayload(existingSubscription);
                const registered = await this.registerDeviceSubscription(existingSubscription);
                this.isSubscribed = registered;
                return {
                    status: 'granted',
                    message: registered
                        ? 'Đã bật thông báo thành công.'
                        : 'Đã có subscription nhưng gửi đăng ký thiết bị chưa thành công.',
                    subscribed: registered,
                    debugInfo: this.buildPushDebugInfo(payload)
                };
            }

            const subscribeParams: PushSubscriptionOptionsInit = { userVisibleOnly: true };
            subscribeParams.applicationServerKey = this.urlB64ToUint8Array('BEY2atWHDb4rGaWezlW3bQA8LCOERm-tZOo45zWIPABpYAUttBb8tFmpkJgHtgqcSxIPOSsqWJc5lM-5-6sZx1w');
            const newSubscription = await registration.pushManager.subscribe(subscribeParams);
            const payload = this.buildPushPayload(newSubscription);
            const registered = await this.registerDeviceSubscription(newSubscription);
            this.isSubscribed = registered;
            return {
                status: 'granted',
                message: registered
                    ? 'Đã bật thông báo thành công.'
                    : 'Tạo subscription thành công nhưng gửi AddDevice chưa thành công.',
                subscribed: registered,
                debugInfo: this.buildPushDebugInfo(payload)
            };
        } catch (error) {
            return {
                status: 'error',
                message: 'Không thể bật thông báo, vui lòng thử lại.',
                subscribed: false
            };
        }
    }

    public async clearPushSubscriptionAndServiceWorkers(): Promise<void> {
        if (!('serviceWorker' in navigator)) {
            return;
        }

        try {
            const registrations = await navigator.serviceWorker.getRegistrations();

            for (const reg of registrations) {
                try {
                    const sub = await reg.pushManager.getSubscription();
                    if (sub) {
                        await sub.unsubscribe();
                    }
                } catch (err) {
                }

                try {
                    await reg.unregister();
                } catch (err) {
                }
            }
        } catch (err) {
        } finally {
            this.isSubscribed = false;
        }
    }
}

